export function setClaims (state, claims) {
  state.claims = claims
}

export function setClaim (state, claim) {
  state._claim = claim
}
